/* ABC Dance Lab · landing + quiz. JavaScript vanilla, sin dependencias.
 * - Idempotente: se puede cargar varias veces (varias secciones) y se reinicia solo en el Theme Editor.
 * - Los datos (horarios, planes, precios, textos) llegan en <script data-abc-config>, generado desde los ajustes de Shopify.
 * - No guarda ni envía datos personales: el nombre, apellido y celular solo viajan dentro del enlace de WhatsApp que abre la persona.
 */
(function () {
  'use strict';
  if (window.__abcMiniDL) { window.__abcMiniDL.scan(document); return; }

  var DAYS = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  var GENRE_NAMES = { salsa: 'Salsa', bachata: 'Bachata', porro: 'Porro', mix: 'Mix (un ritmo diferente por clase)', danza_arabe: 'Danza Árabe', lady_style_bachata: 'Lady Style de Bachata' };
  var SYS = {
    prefs: 'Tus preferencias',
    plan: 'Tu plan mensual',
    genresOne: 'Elige tu ritmo',
    genresTwo: 'Elige 2 ritmos diferentes',
    groupsFor: 'Elige tu grupo base de {genre}',
    slots: '{n} horarios disponibles',
    oneSlot: '1 horario disponible',
    noSlots: 'Sin grupos programados',
    conflict: 'Se cruza con tu otro grupo',
    classesMonth: '{n} clases principales al mes',
    group: 'Grupo base',
    sameDay: 'Tienes dos clases el mismo día. Confirmaremos contigo el tiempo entre ambas.',
    workshopClash: 'Esta clase coincide con el {name}. Elige otro horario o consúltalo con un asesor.',
    errGenresOne: 'Elige un ritmo para continuar.',
    errGenresTwo: 'Elige dos ritmos diferentes para este plan, o cambia al plan de 1 género.',
    included: 'incluido',
    month4: 'clase',
    notRecommendedNote: 'Puedes cambiar de plan cuando quieras.',
    anyTime: 'Puedo adaptarme a varios horarios',
    undecidedTag: 'no tenía claro el ritmo al empezar',
    wsLabel: 'Taller',
    changeGroup: 'Cambiar',
    play: 'Reproducir video'
  };

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var instances = new WeakMap();
  var list = [];

  /* ---------- utilidades ---------- */
  function el(tag, props) {
    var node = document.createElement(tag);
    if (props) {
      Object.keys(props).forEach(function (k) {
        var v = props[k];
        if (v === null || v === undefined || v === false) return;
        if (k === 'class') node.className = v;
        else if (k === 'text') node.textContent = v;
        else if (k === 'on') Object.keys(v).forEach(function (ev) { node.addEventListener(ev, v[ev]); });
        else node.setAttribute(k, v === true ? '' : v);
      });
    }
    for (var i = 2; i < arguments.length; i++) {
      var c = arguments[i];
      if (c === null || c === undefined || c === false) continue;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    }
    return node;
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function stripEmoji(s) { return String(s || '').replace(/^[^\p{L}\p{N}¡¿]+/u, '').trim(); }
  function tpl(s, vars) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] !== undefined ? vars[k] : m; }); }
  function toMin(t) { var p = String(t).split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10); }
  function fmtTime(t) {
    var p = String(t).split(':'); var h = parseInt(p[0], 10); var m = p[1] || '00';
    var hh = h % 12 === 0 ? 12 : h % 12;
    return hh + ':' + m + (h < 12 ? ' a. m.' : ' p. m.');
  }
  function fmtPrice(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function track(name, data) {
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, data || {}); } catch (e) { /* analítica opcional */ }
    try { document.dispatchEvent(new CustomEvent('abc-dance-lab:' + name, { detail: data || {} })); } catch (e) { /* noop */ }
  }
  function cleanText(v) {
    return String(v || '').replace(/[\u0000-\u001f\u007f​-‏‪-‮⁦-⁩]/g, '').replace(/\s+/g, ' ').trim();
  }
  function validName(v) { return /^[\p{L}\p{M}][\p{L}\p{M}'’.\- ]{1,59}$/u.test(v); }
  function normPhone(v) {
    var d = String(v || '').replace(/[\s\-().]/g, '');
    if (d.indexOf('+57') === 0) d = d.slice(3);
    else if (/^57\d{10}$/.test(d)) d = d.slice(2);
    return /^3\d{9}$/.test(d) ? d : null;
  }
  function fmtPhone(d) { return '+57 ' + d.slice(0, 3) + ' ' + d.slice(3, 6) + ' ' + d.slice(6); }
  function smoothScroll(node) {
    if (!node) return;
    var top = node.getBoundingClientRect().top + window.pageYOffset - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* ---------- video bajo demanda ---------- */
  function loadVideo(wrap, userInitiated) {
    if (!wrap || wrap.querySelector('video')) return;
    var t = $('template[data-abc-video-tpl]', wrap);
    if (!t) return;
    var v = t.content.cloneNode(true).querySelector('video');
    if (!v) return;
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'metadata');
    if (userInitiated) v.muted = false; else v.muted = true;
    $$('video', document).forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
    wrap.appendChild(v);
    wrap.classList.add('is-playing');
    var btn = $('[data-abc-play]', wrap);
    if (btn) btn.hidden = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.controls = true; });
  }
  function initVideos(ctx) {
    $$('[data-abc-video]', ctx).forEach(function (wrap) {
      if (wrap.__abcVid) return; wrap.__abcVid = true;
      var btn = $('[data-abc-play]', wrap);
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); loadVideo(wrap, true); });
      if (wrap.hasAttribute('data-abc-autoplay')) {
        var conn = navigator.connection || {};
        if (reduceMotion || conn.saveData) return;
        var go = function () { loadVideo(wrap, false); };
        var start = function () { if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 800); };
        if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
      }
    });
  }

  /* ---------- Funnel ---------- */
  function Funnel(root) {
    this.root = root;
    var cfgEl = $('script[data-abc-config]', root);
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null;
    if (!this.cfg) return;
    var sysT = (this.cfg.text && this.cfg.text.sys) || {};
    Object.keys(sysT).forEach(function (k) { if (sysT[k]) SYS[k] = sysT[k]; });
    this.quiz = $('[data-abc-quiz]', root);
    this.resultBox = $('[data-abc-result]', root);
    this.state = { screen: '1', experience: null, rhythms: [], times: [], motivation: null, planOverride: null, plan: 'a', genres: [], picks: {}, completed: false, started: false, nomatch: false, warn: '' };
    this.stack = ['1'];
    this.bind();
    initVideos(root);
    this.updateProgress('1');
    try { history.replaceState({ abc: '1', idx: 0 }, '', location.href); } catch (e) { /* noop */ }
  }

  Funnel.prototype.bind = function () {
    var self = this, root = this.root;
    this._click = function (e) {
      var t = e.target.closest ? e.target.closest('[data-abc-next],[data-abc-back],[data-abc-back-result],[data-abc-select-plan]') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-abc-next')) self.next();
      else if (t.hasAttribute('data-abc-back')) self.back();
      else if (t.hasAttribute('data-abc-back-result')) self.show('result', true);
      else if (t.hasAttribute('data-abc-select-plan')) self.selectPlanFromCard(t.getAttribute('data-abc-select-plan'));
    };
    root.addEventListener('click', this._click);

    this._change = function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-abc-input]')) return;
      self.onInput(t);
    };
    root.addEventListener('change', this._change);

    this._pop = function (e) {
      var st = e.state;
      if (!st || !st.abc) return;
      var target = st.abc;
      if ((target === 'result' || target === 'data') && !self.state.completed) target = '1';
      self.stack = self.stack.slice(0, (st.idx || 0) + 1);
      self.show(target, false);
    };
    window.addEventListener('popstate', this._pop);

    var form = $('[data-abc-form]', root);
    if (form) {
      this._submit = function (e) { e.preventDefault(); self.submit(form); };
      form.addEventListener('submit', this._submit);
      $$('input', form).forEach(function (inp) { inp.addEventListener('input', function () { self.fieldError(form, inp.name, false); }); inp.addEventListener('change', function () { self.fieldError(form, inp.name, false); }); });
    }
  };

  Funnel.prototype.destroy = function () {
    this.root.removeEventListener('click', this._click);
    this.root.removeEventListener('change', this._change);
    window.removeEventListener('popstate', this._pop);
  };

  /* ----- navegación ----- */
  Funnel.prototype.screenEl = function (name) { return $('[data-abc-screen="' + name + '"]', this.root); };

  Funnel.prototype.updateProgress = function (name) {
    var prog = $('[data-abc-progress]', this.root);
    var n = parseInt(name, 10);
    if (!n) { if (prog) prog.hidden = true; return; }
    if (prog) prog.hidden = false;
    var label = $('[data-abc-progress-label]', this.root);
    if (label) label.textContent = tpl(this.cfg.text.progress, { n: n, total: 3 });
    var bar = $('[data-abc-progressbar]', this.root);
    if (bar) bar.setAttribute('aria-valuenow', String(n));
    var fill = $('[data-abc-progressfill]', this.root);
    if (fill) fill.style.width = (n / 3 * 100) + '%';
  };

  Funnel.prototype.show = function (name, push, opts) {
    var self = this;
    $$('[data-abc-screen]', this.root).forEach(function (s) { s.hidden = s.getAttribute('data-abc-screen') !== name; });
    this.state.screen = name;
    this.root.setAttribute('data-abc-current', name);
    this.updateProgress(name);
    if (name === 'result') this.renderResult();
    if (name === 'data') this.renderRecap();
    if (push) {
      this.stack.push(name);
      try { history.pushState({ abc: name, idx: this.stack.length - 1 }, '', location.href); } catch (e) { /* noop */ }
    }
    var s = this.screenEl(name);
    var focusEl = s ? ($('[data-abc-focus]', s) || s) : null;
    if (focusEl) { if (!focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1'); try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); } }
    if (!(opts && opts.noScroll)) smoothScroll(this.quiz);
    initVideos(this.quiz);
  };

  Funnel.prototype.start = function () {
    if (!this.state.started) { this.state.started = true; track('quiz_started', {}); }
    var s = this.screenEl(this.state.screen);
    var focusEl = s ? ($('[data-abc-focus]', s) || s) : null;
    smoothScroll(this.quiz);
    if (focusEl) { try { focusEl.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
  };

  Funnel.prototype.goConfirm = function () {
    if (this.state.completed) { this.start(); this.show(this.state.screen === 'data' ? 'data' : 'result', true); }
    else this.start();
  };

  Funnel.prototype.back = function () {
    var cur = this.state.screen;
    var prev = cur === 'data' ? 'result' : cur === 'result' ? '3' : String(Math.max(1, parseInt(cur, 10) - 1));
    if (this.stack.length > 1 && this.stack[this.stack.length - 2] === prev) { history.back(); return; }
    this.stack = this.stack.slice(0, Math.max(1, this.stack.length - 1));
    this.show(prev, false);
  };

  /* ----- respuestas ----- */
  Funnel.prototype.errorBox = function (screen) { return $('[data-abc-error]', this.screenEl(screen)); };
  Funnel.prototype.setError = function (screen, msg) {
    var b = this.errorBox(screen); if (!b) return;
    if (msg) { b.textContent = msg; b.hidden = false; } else { b.textContent = ''; b.hidden = true; }
  };

  Funnel.prototype.onInput = function (input) {
    var st = this.state, kind = input.getAttribute('data-abc-input');
    if (!st.started) { st.started = true; track('quiz_started', {}); }
    if (kind === 'experience') {
      st.experience = input.value;
      this.setError('1', '');
      var hint = $('[data-abc-q1-hint]', this.root); if (hint) hint.hidden = st.experience !== 'beginner';
    } else if (kind === 'motivation') {
      st.motivation = input.value; this.setError('3', '');
    } else if (kind === 'rhythm') {
      var boxes = $$('[data-abc-input="rhythm"]', this.root);
      if (input.checked) {
        if (input.value === 'undecided') boxes.forEach(function (b) { if (b !== input) b.checked = false; });
        else {
          boxes.forEach(function (b) { if (b.value === 'undecided') b.checked = false; });
          var on = boxes.filter(function (b) { return b.checked && b.value !== 'undecided'; });
          if (on.length > 2) { input.checked = false; this.setError('2', this.cfg.text.q2Max); st.rhythms = this.readRhythms(); return; }
        }
      }
      st.rhythms = this.readRhythms(); this.setError('2', '');

    }
  };
  Funnel.prototype.readRhythms = function () {
    return $$('[data-abc-input="rhythm"]', this.root).filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
  };

  Funnel.prototype.next = function () {
    var st = this.state, cur = st.screen, E = this.cfg.text.err;
    if (cur === '1') { if (!st.experience) return this.setError('1', E.q1); }
    if (cur === '2') { if (!st.rhythms.length) return this.setError('2', E.q2); }
    if (cur === '3') { if (!st.motivation) return this.setError('3', E.q4); }
    var n = parseInt(cur, 10);
    track('quiz_step_completed', { step: n });
    if (n < 3) { this.show(String(n + 1), true); return; }
    st.completed = true;
    this.initResult();
    track('quiz_completed', { experience: st.experience, rhythms: st.rhythms.join(','), times: st.times.join(','), motivation: st.motivation });
    this.show('result', true);
  };

  /* ----- lógica de recomendación ----- */
  Funnel.prototype.eligible = function (genre) {
    return this.cfg.classes.filter(function (c) {
      return c.rhythm === genre;
    }).sort(function (a, b) { return a.day - b.day || toMin(a.time) - toMin(b.time); });
  };
  Funnel.prototype.needsValidation = function (c) { return this.state.experience === 'experienced' || c.audience !== 'beginner'; };
  Funnel.prototype.overlap = function (a, b) {
    if (a.day !== b.day) return false;
    var d = this.cfg.classDuration;
    if (d > 0) return Math.abs(toMin(a.time) - toMin(b.time)) < d;
    return toMin(a.time) === toMin(b.time);
  };
  Funnel.prototype.recommendedPlan = function () {
    var n = this.state.rhythms.filter(function (r) { return r !== 'undecided'; }).length;
    return n === 2 ? 'b' : 'a';
  };
  Funnel.prototype.initResult = function () {
    var st = this.state;
    st.plan = st.planOverride || this.recommendedPlan();
    var g = st.rhythms.filter(function (r) { return r !== 'undecided'; });
    st.genres = g.slice(0, this.cfg.plans[st.plan].genres);
    st.picks = {};
    st.warn = '';
    this.syncPicks();
  };
  Funnel.prototype.syncPicks = function (pref) {
    var self = this, st = this.state;
    var opts = {}, keep = {};
    st.genres.forEach(function (g) {
      opts[g] = self.eligible(g).slice().sort(function (a, b) {
        var preferA = st.experience !== 'experienced' && a.audience === 'beginner' ? 0 : 1;
        var preferB = st.experience !== 'experienced' && b.audience === 'beginner' ? 0 : 1;
        return preferA - preferB || a.day - b.day || toMin(a.time) - toMin(b.time);
      });
    });
    var clash = function (c, list) { return list.some(function (o) { return self.overlap(o, c); }); };
    var valid = function (g) { return opts[g].filter(function (c) { return c.id === st.picks[g]; })[0] || null; };
    var order = st.genres.slice().sort(function (a, b) { return (a === pref ? -1 : 0) - (b === pref ? -1 : 0); });
    var kept = [];
    order.forEach(function (g) {
      var cur = valid(g);
      if (cur && !clash(cur, kept)) { keep[g] = cur; kept.push(cur); }
    });
    var free = st.genres.filter(function (g) { return !keep[g]; });
    var best = null;
    (function rec(i, chosen) {
      if (i === free.length) { var n = chosen.filter(Boolean).length; if (!best || n > best.n) best = { n: n, chosen: chosen.slice() }; return; }
      var g = free[i], base = kept.concat(chosen.filter(Boolean));
      opts[g].forEach(function (c) { if (!clash(c, base)) rec(i + 1, chosen.concat([c])); });
      rec(i + 1, chosen.concat([null]));
    })(0, []);
    var picks = {};
    st.genres.forEach(function (g) { if (keep[g]) picks[g] = keep[g].id; });
    if (best) best.chosen.forEach(function (c, i) { if (c) picks[free[i]] = c.id; });
    st.picks = picks;
  };
  Funnel.prototype.classById = function (id) { return this.cfg.classes.filter(function (c) { return c.id === id; })[0]; };
  Funnel.prototype.chosenClasses = function () {
    var self = this;
    return this.state.genres.map(function (g) { return self.classById(self.state.picks[g]); }).filter(Boolean);
  };

  Funnel.prototype.selectPlanFromCard = function (key) {
    var st = this.state, p = this.cfg.plans[key];
    if (!p) return;
    st.planOverride = key;
    track('plan_selected', { plan: key, price: p.price });
    if (st.completed) {
      var wanted = st.rhythms.filter(function (r) { return r !== 'undecided'; });
      st.plan = key;
      st.genres = st.genres.concat(wanted.filter(function (r) { return st.genres.indexOf(r) === -1; })).slice(0, p.genres);
      this.syncPicks();
      this.show('result', st.screen !== 'result');
    } else {
      var note = $('[data-abc-plan-note]', this.root);
      if (note) { note.textContent = tpl(this.cfg.text.planNote, { plan: p.name + ' · ' + p.priceText }); note.hidden = false; }
      this.start();
    }
  };

  /* ----- render del resultado ----- */
  Funnel.prototype.renderResult = function () {
    var self = this, st = this.state, cfg = this.cfg, T = cfg.text.res;
    var box = this.resultBox; box.textContent = '';
    var plan = cfg.plans[st.plan];
    var undecided = st.rhythms.indexOf('undecided') !== -1;
    var rec = this.recommendedPlan();

    // Inicio limpio del resultado: solo titulo, sin chips, subtitulos, avisos ni callouts redundantes.
    box.appendChild(el('div', { class: 'abc-step__body abc-step__body--wide' },
      el('h2', { class: 'abc-q abc-q--result', 'data-abc-focus': '', tabindex: '-1', text: T.title })
    ));
    var body = box.firstChild;

    /* plan */
    var planWrap = el('div', { class: 'abc-block' }, el('h3', { class: 'abc-h3', text: SYS.plan }));
    var radios = el('div', { class: 'abc-plansel', role: 'radiogroup', 'aria-label': SYS.plan });
    ['a', 'b'].forEach(function (k) {
      var p = cfg.plans[k], on = st.plan === k;
      radios.appendChild(el('button', {
        type: 'button', role: 'radio', 'aria-checked': on ? 'true' : 'false', 'data-key': 'plan-' + k, class: 'abc-planbtn' + (on ? ' is-on' : ''),
        on: { click: function () { self.setPlan(k); } }
      },
        k === rec ? el('span', { class: 'abc-badge', text: T.recommended }) : null,
        el('span', { class: 'abc-planbtn__name', text: p.name }),
        el('span', { class: 'abc-planbtn__price' }, el('strong', { text: p.priceText }), ' ' + (SYS.planPer || 'COP / mes')),
        el('span', { class: 'abc-planbtn__sum', text: tpl(SYS.classesMonth, { n: p.genres * cfg.classesPerGenre }) })
      ));
    });
    planWrap.appendChild(radios);
    body.appendChild(planWrap);

    /* ritmos */
    var gWrap = el('div', { class: 'abc-block' }, el('h3', { class: 'abc-h3', text: plan.genres === 1 ? SYS.genresOne : SYS.genresTwo }));
    var gGrid = el('div', { class: 'abc-genres', role: 'group', 'aria-label': plan.genres === 1 ? SYS.genresOne : SYS.genresTwo });
    var order = Object.keys(GENRE_NAMES);
    if (undecided) order.sort(function (a, b) { return self.eligible(b).length - self.eligible(a).length; });
    order.forEach(function (g) {
      var n = self.eligible(g).length, on = st.genres.indexOf(g) !== -1;
      gGrid.appendChild(el('button', {
        type: 'button', 'aria-pressed': on ? 'true' : 'false', 'data-key': 'genre-' + g, class: 'abc-genrebtn' + (on ? ' is-on' : ''),
        on: { click: function () { self.toggleGenre(g); } }
      },
        el('span', { class: 'abc-genrebtn__name', text: GENRE_NAMES[g] }),
        el('span', { class: 'abc-genrebtn__blurb', text: T.blurb[g] }),
        el('span', { class: 'abc-genrebtn__slots' + (n ? '' : ' is-empty'), text: n === 0 ? SYS.noSlots : n === 1 ? SYS.oneSlot : tpl(SYS.slots, { n: n }) })
      ));
    });
    gWrap.appendChild(gGrid);
    if (st.genres.length < plan.genres) gWrap.appendChild(el('p', { class: 'abc-callout', role: 'status', text: plan.genres === 1 ? SYS.errGenresOne : SYS.errGenresTwo }));
    gWrap.appendChild(el('p', { class: 'abc-error', role: 'alert', 'data-abc-genre-error': '', hidden: true }));
    body.appendChild(gWrap);

    /* grupos por ritmo */
    var anyMatch = false;
    st.genres.forEach(function (g) {
      var opts = self.eligible(g);
      var blockEl = el('div', { class: 'abc-block' }, el('h3', { class: 'abc-h3', id: 'abc-gh-' + g, text: tpl(SYS.groupsFor, { genre: GENRE_NAMES[g] }) }));
      if (!opts.length) {
        blockEl.appendChild(self.noMatchCard(g));
      } else {
        anyMatch = true;
        var grp = el('div', { class: 'abc-groups', role: 'radiogroup', 'aria-labelledby': 'abc-gh-' + g });
        opts.forEach(function (c) {
          var picked = st.picks[g] === c.id;
          var clash = !picked && self.otherPicks(g).some(function (o) { return self.overlap(o, c); });
          var limited = cfg.urgency && (c.limited || cfg.limitedConfirmed);
          var btn = el('button', {
            type: 'button', role: 'radio', 'aria-checked': picked ? 'true' : 'false', 'aria-disabled': clash ? 'true' : null, 'data-key': 'group-' + c.id,
            class: 'abc-groupbtn' + (picked ? ' is-on' : '') + (clash ? ' is-disabled' : ''),
            on: { click: function () { if (!clash) self.pickGroup(g, c.id); } }
          },
            el('span', { class: 'abc-groupbtn__when', text: DAYS[c.day] + ' · ' + fmtTime(c.time) }),
            el('span', { class: 'abc-groupbtn__what', text: GENRE_NAMES[g] + ' · ' + c.level + (c.room ? ' · ' + c.room : '') }),
            self.needsValidation(c) ? el('span', { class: 'abc-tag', text: T.validateTag }) : null,
            limited ? el('span', { class: 'abc-tag abc-tag--hot', text: cfg.hooks.few }) : null,
            clash ? el('span', { class: 'abc-tag abc-tag--muted', text: SYS.conflict }) : null
          );
          grp.appendChild(btn);
        });
        blockEl.appendChild(grp);
        if (cfg.urgency) blockEl.appendChild(el('p', { class: 'abc-note', text: cfg.hooks.cap }));
      }
      body.appendChild(blockEl);
    });

    st.nomatch = st.genres.length > 0 && !anyMatch;

    body.appendChild(this.monthModule());

    body.appendChild(el('p', { class: 'abc-error', role: 'alert', 'data-abc-result-error': '', hidden: true }));
    var monthActions = this.resultBox.querySelector('.abc-month');
    if (monthActions) monthActions.appendChild(el('div', { class: 'abc-nav abc-nav--result' },
      el('button', { type: 'button', class: 'abc-btn abc-btn--ghost', text: T.changeAnswers, on: { click: function () { self.show('1', true); } } }),
      el('button', { type: 'button', class: 'abc-btn abc-btn--cta', 'data-key': 'continue', text: T.cta, on: { click: function () { self.toData(); } } })
    ));
    body.appendChild(el('p', { class: 'abc-note', text: T.scheduleNote }));
    initVideos(box.parentNode);
  };

  Funnel.prototype.otherPicks = function (genre) {
    var self = this;
    return this.state.genres.filter(function (g) { return g !== genre; }).map(function (g) { return self.classById(self.state.picks[g]); }).filter(Boolean);
  };

  Funnel.prototype.noMatchCard = function (genre) {
    var self = this, T = this.cfg.text.res;
    return el('div', { class: 'abc-nomatch' },
      el('p', { text: T.noMatch }),
      el('div', { class: 'abc-nav abc-nav--stack' },
        el('button', { type: 'button', class: 'abc-btn abc-btn--ghost', text: T.noMatchChange, on: { click: function () { self.show('2', true); } } }),
        el('button', { type: 'button', class: 'abc-btn abc-btn--cta', text: T.noMatchWa, on: { click: function () { self.state.nomatch = true; self.toData(true); } } })
      )
    );
  };

  Funnel.prototype.monthModule = function () {
    var self = this, st = this.state, cfg = this.cfg, T = cfg.text.res, plan = cfg.plans[st.plan];
    var wrap = el('div', { class: 'abc-block abc-month' }, el('h3', { class: 'abc-h3', text: T.monthTitle }));
    wrap.appendChild(el('p', { class: 'abc-month__total' }, el('strong', { text: tpl(SYS.classesMonth, { n: plan.genres * cfg.classesPerGenre }) }), ' · ' + plan.priceText + ' COP/mes'));
    var rows = el('div', { class: 'abc-month__rows' });
    var warns = [];
    var chosen = this.chosenClasses();
    st.genres.forEach(function (g) {
      var c = self.classById(st.picks[g]);
      rows.appendChild(el('div', { class: 'abc-month__row' },
        el('span', { class: 'abc-month__g', text: GENRE_NAMES[g] }),
        el('span', { class: 'abc-month__d', text: c ? SYS.group + ': ' + DAYS[c.day] + ' ' + fmtTime(c.time) : '—' })
      ));
    });
    var w = cfg.workshop;
    rows.appendChild(el('div', { class: 'abc-month__row abc-month__row--ws' },
      el('span', { class: 'abc-month__g', text: w.name }),
      el('span', { class: 'abc-month__d', text: DAYS[w.day] + (w.day >= 6 ? 's ' : ' ') + fmtTime(w.time) + ' · ' + SYS.included })
    ));
    wrap.appendChild(rows);
    chosen.forEach(function (c) {
      if (c.day === w.day && self.overlap(c, { day: w.day, time: w.time })) warns.push(tpl(SYS.workshopClash, { name: w.name }));
    });
    if (chosen.length === 2 && chosen[0].day === chosen[1].day) warns.push(SYS.sameDay);
    warns.forEach(function (m) { wrap.appendChild(el('p', { class: 'abc-callout abc-callout--warn', role: 'status', text: m })); });
    wrap.appendChild(el('p', { class: 'abc-month__extras' }, el('strong', { text: T.extrasLabel }), ' ', T.extrasText));
    return wrap;
  };

  Funnel.prototype.refocus = function (key) {
    if (!key) return;
    var node = this.resultBox.querySelector('[data-key="' + key + '"]');
    if (node) { try { node.focus({ preventScroll: true }); } catch (e) { node.focus(); } }
  };

  Funnel.prototype.setPlan = function (k) {
    var st = this.state, p = this.cfg.plans[k];
    st.plan = k; st.planOverride = k;
    var wanted = st.rhythms.filter(function (r) { return r !== 'undecided'; });
    st.genres = st.genres.concat(wanted.filter(function (r) { return st.genres.indexOf(r) === -1; })).slice(0, p.genres);
    this.syncPicks();
    track('plan_selected', { plan: k, price: p.price });
    this.renderResult(); this.refocus('plan-' + k);
  };

  Funnel.prototype.toggleGenre = function (g) {
    var st = this.state, max = this.cfg.plans[st.plan].genres, i = st.genres.indexOf(g);
    var msg = '';
    if (max === 1) { st.genres = [g]; }
    else if (i !== -1) { st.genres.splice(i, 1); }
    else if (st.genres.length >= max) { msg = this.cfg.text.q2Max; }
    else { st.genres.push(g); }
    this.syncPicks();
    this.renderResult();
    var e = $('[data-abc-genre-error]', this.resultBox);
    if (e && msg) { e.textContent = msg; e.hidden = false; }
    this.refocus('genre-' + g);
  };

  Funnel.prototype.pickGroup = function (g, id) {
    this.state.picks[g] = id;
    this.syncPicks(g);
    var c = this.classById(id);
    if (c) track('schedule_selected', { rhythm: g, day: c.day, time: c.time });
    this.renderResult(); this.refocus('group-' + id);
  };

  Funnel.prototype.toData = function (forceNoMatch) {
    var st = this.state, plan = this.cfg.plans[st.plan];
    var e = $('[data-abc-result-error]', this.resultBox);
    if (st.genres.length !== plan.genres) {
      if (e) { e.textContent = plan.genres === 1 ? SYS.errGenresOne : SYS.errGenresTwo; e.hidden = false; }
      return;
    }
    st.nomatch = !!forceNoMatch || st.genres.every(function (g) { return !st.picks[g]; });
    this.show('data', true);
  };

  Funnel.prototype.groupsText = function () {
    var self = this, st = this.state, T = this.cfg.text;
    return st.genres.map(function (g) {
      var c = self.classById(st.picks[g]);
      return c ? GENRE_NAMES[g] + ' ' + c.level + ' — ' + DAYS[c.day] + ' ' + fmtTime(c.time) : GENRE_NAMES[g] + ': ' + T.wa.noMatch;
    }).join(' | ');
  };

  Funnel.prototype.renderRecap = function () {
    var st = this.state, plan = this.cfg.plans[st.plan], ul = $('[data-abc-recap]', this.root);
    if (!ul) return;
    ul.textContent = '';
    var self = this;
    [plan.name + ' · ' + (plan.priceText + ' COP/mes')].concat(st.genres.map(function (g) {
      var c = self.classById(st.picks[g]);
      return GENRE_NAMES[g] + (c ? ' · ' + DAYS[c.day] + ' ' + fmtTime(c.time) : '');
    })).forEach(function (t) { ul.appendChild(el('li', { text: t })); });
  };

  /* ----- formulario y WhatsApp ----- */
  Funnel.prototype.fieldError = function (form, name, show) {
    var p = $('[data-abc-err="' + name + '"]', form), inp = form.elements[name];
    if (p) p.hidden = !show;
    if (inp) { if (show) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid'); }
  };

  Funnel.prototype.buildMessage = function (v) {
    var st = this.state, cfg = this.cfg, t = cfg.text, plan = cfg.plans[st.plan];
    var genres = st.genres.map(function (g) { return GENRE_NAMES[g]; }).join(' y ');
    if (st.rhythms.indexOf('undecided') !== -1) genres += ' (' + SYS.undecidedTag + ')';
    var lines = [
      '💃 *' + t.wa.intro + '*', '',
      '👤 *DATOS DE CONTACTO*',
      'Nombre: ' + v.first,
      'Apellido: ' + v.last,
      '📱 Celular: ' + fmtPhone(v.phone), '',
      '🎶 *MIS PREFERENCIAS*',
      'Experiencia: ' + stripEmoji(t.q1[st.experience]),
      'Cursos: ' + genres,
      '📅 Grupos elegidos: ' + (st.nomatch && st.genres.every(function (g) { return !st.picks[g]; }) ? t.wa.noMatch : this.groupsText()), '',
      '🎟️ *PLAN Y MENSUALIDAD*',
      'Plan: ' + (plan.genres === 1 ? '1 género' : '2 géneros'),
      'Precio: ' + (plan.priceText + ' COP/mes'),
      '✨ Motivación: ' + stripEmoji(t.q4[st.motivation])
    ];
    if (v.practices) lines.push('', '💛 Quiero información sobre las Prácticas Generales y la Troncoteca.');
    lines.push('', '✅ ' + t.wa.closing);
    return lines.join('\n');
  };

  Funnel.prototype.submit = function (form) {
    var self = this, E = this.cfg.text.data, ok = true, first = null;
    var vals = {
      first: cleanText(form.elements.first_name.value),
      last: cleanText(form.elements.last_name.value),
      phone: normPhone(form.elements.phone.value),
      consent: form.elements.consent.checked,
      practices: form.elements.practices.checked
    };
    var checks = [
      ['first_name', validName(vals.first)],
      ['last_name', validName(vals.last)],
      ['phone', !!vals.phone],
      ['consent', vals.consent]
    ];
    checks.forEach(function (c) {
      self.fieldError(form, c[0], !c[1]);
      if (!c[1]) { ok = false; if (!first) first = form.elements[c[0]]; }
    });
    if (!ok) { if (first) first.focus(); return; }
    if (!this.cfg.privacyReady || !this.cfg.whatsapp) return;
    var url = 'https://wa.me/' + this.cfg.whatsapp + '?text=' + encodeURIComponent(this.buildMessage(vals));
    var plan = this.cfg.plans[this.state.plan];
    track('whatsapp_clicked', { plan: this.state.plan, price: plan.price, genres: this.state.genres.join(','), no_match: this.state.nomatch });
    var fb = $('[data-abc-fallback]', form);
    if (fb) fb.setAttribute('href', url);
    var sent = $('[data-abc-sent]', form); if (sent) sent.hidden = false;
    var w = window.open(url, '_blank', 'noopener,noreferrer');
    if (!w) window.location.href = url;
  };

  /* ---------- arranque global ---------- */
  function init(root) {
    if (instances.has(root)) return;
    var f = new Funnel(root);
    if (!f.cfg) return;
    instances.set(root, f); list.push(f);
  }
  function main() { return list[0] || null; }

  function replaceTokens(ctx) {
    var f = main(); if (!f) return;
    var map = { '{precio_a}': f.cfg.plans.a.priceText, '{precio_b}': f.cfg.plans.b.priceText, '{clases_genero}': String(f.cfg.classesPerGenre) };
    $$('[data-abc-tokens]', ctx).forEach(function (n) {
      if (n.__abcTok) return; n.__abcTok = true;
      var t = n.textContent;
      Object.keys(map).forEach(function (k) { t = t.split(k).join(map[k]); });
      n.textContent = t;
    });
  }

  function scan(ctx) {
    $$('[data-abc-mini-root]', ctx).forEach(init);
    initVideos(ctx);
    replaceTokens(ctx);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-abc-action]') : null;
    if (!a) return;
    var f = main(); if (!f || !f.root.contains(a)) return;
    var act = a.getAttribute('data-abc-action');
    if (act === 'start') { e.preventDefault(); f.start(); }
    else if (act === 'confirm') { e.preventDefault(); f.goConfirm(); }
    else if (act === 'plans') { var p = $('[id^="abc-plans-"]', f.root); if (p) { e.preventDefault(); smoothScroll(p); try { p.focus({ preventScroll: true }); } catch (x) { /* noop */ } } }
  });

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-abc-mini-root]', e.target).forEach(function (r) {
      var f = instances.get(r); if (f) { f.destroy(); list.splice(list.indexOf(f), 1); instances.delete(r); }
    });
  });

  window.__abcMiniDL = { scan: scan, instances: instances, list: list };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
})();
